var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Category")]),_c('h3',[_vm._v("New Category")]),(_vm.categories.loading)?[_c('Loader')]:[_c('CategoryForm',{attrs:{"parent-values":_vm.categoriesParentValues},on:{"submit":_vm.submit}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }